// extracted by mini-css-extract-plugin
export default {"RegistrationEnd":"RegistrationEnd_RegistrationEnd__tBTDf","RegistrationEndInner":"RegistrationEnd_RegistrationEndInner__IIYbu","buttonText":"RegistrationEnd_buttonText__LVU9b"};